import { api } from './client';
import type { AiBalance, AiProvider, AiSettings, AiUsageSummary } from '@mycompbox/shared';
import type { Job } from './mailbox';

export type { AiBalance, AiProvider, AiSettings, AiUsageSummary };

export interface SaveAiKeyInput {
  provider: AiProvider;
  apiKey: string;
  model: string;
}

/** The caller's AI keys: their own and the company key they inherit. Keys are never returned. */
export const aiSettingsApi = {
  get: () => api.get<{ data: AiSettings }>('/ai-settings'),

  balance: () => api.get<{ data: AiBalance }>('/ai-settings/balance'),

  verifyKey: (provider: AiProvider, apiKey: string) =>
    api.post<{ data: { models: string[] } }>('/ai-settings/verify', { provider, apiKey }),

  savePersonalKey: (input: SaveAiKeyInput) => api.put<{ data: AiSettings }>('/ai-settings/key', input),

  deletePersonalKey: () => api.delete<{ data: AiSettings }>('/ai-settings/key'),

  saveCompanyKey: (input: SaveAiKeyInput) => api.put<{ data: AiSettings }>('/ai-settings/company-key', input),

  deleteCompanyKey: () => api.delete<{ data: AiSettings }>('/ai-settings/company-key'),

  /** This month's AI spend on the caller's key, and savings from prompt caching. */
  usage: () => api.get<{ data: AiUsageSummary }>('/ai-settings/usage'),

  /** Start a request interview that runs on CompBox's server with the API key. */
  /**
   * Start an interview on the API key. With `epicRequestId` (ENG-291) the
   * interview discusses that existing Epic Request and updates it in place.
   */
  startKeyInterview: (input: { epicRequestId?: string; project?: string } = {}) =>
    api.post<{ data: Job }>('/ai-settings/key-interviews', input),

  /** Take a key interview's next step; a no-op unless it's waiting on the AI. */
  advanceKeyInterview: (jobId: string) =>
    api.post<{ data: Job }>(`/ai-settings/key-interviews/${jobId}/advance`, {}),
};
